import React, { useEffect, useState, useRef } from 'react';
import Tags from './Tags';
import { ILoadPicParams } from '../../store/GalleryStore';
import useScrollFixElement from '../hooks/useScrollFixElement';
import {
  checkLoadMore,
  ILoadMoreResult,
  ICheckLoadMore
} from '../Common/ListWrapper';

interface IAllForTag {
  // ref?: React.RefObject<any>;
  // isFixed?: boolean;
  loadPic: (params: ILoadPicParams) => any;
  disableSystem?: boolean;
  showperson?: boolean;
  showall?: boolean;
  showhot?: boolean;
}

interface IOneTag {
  name: string;
  id: number;
}

let lastTagId = 0;

const AllForTag = (props:IAllForTag)=>{
  let tags = [];

  useEffect(() => {
    // 这玩意本来可以不在这里执行的，不过考虑到只想渲染一次，就放这里了
    if (window.dataDetail) {
      tags = (window.dataDetail.tags || '').split(',').map((tag, index) => ({
        name: tag,
        id: index + 100 // 由于0，1 被关键值全部等占据了，所以这里直接从100开始使用
      }));
      setTagList(tags);
    }
  }, []);
  const { loadPic } = props;
  const [tagList, setTagList] = useState<IOneTag[]>([]);
  const [selectTagId, setSelectTagId] = useState(0);

  useEffect(()=>{
    
  }, []);

  const clickTag = (id: number) => {
    setSelectTagId(id);
    // 注意ID和name的对应关系， <=0的是系统默认的，单独处理；100以上的是将window.dataDetail.tags分割后的
    lastTagId = id;
    // 防止已经到底后无法加载更多
    window.dispatchEvent(new Event('set-is-end-false'));

    // 重置了到底标签后，实际上还要将滚动条回到顶部，但此处内容，是否要做到 setIsEnd 逻辑里，还不确定 2019-10-23
    try {
      const tillParent = document.querySelector('.gallery-home')!;

      if (tillParent && tillParent.parentElement) {
        tillParent.parentElement.scrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth'
        });
      }
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
    } catch (e) {}

    // 系统级别
    if (id < 100) {
      if (id === 0) {
        // 全部
        loadPic({
          notmerge: true,
          tag: '',
          person: false,
          hot: false
        }).then(checkLoadMore);
      } else if (id === -1) {
        // 人物
        loadPic({ notmerge: true, person: true, hot: false });
      } else if (id === -2) {
        //热门
        loadPic({ notmerge: true, hot: true, person: false });
      }
    } else {
      const index = id - 100;
      const tag = (window.dataDetail!.tags || '').split(',')[index];
      loadPic({ tag, notmerge: true, person: false, hot: false }).then(
        checkLoadMore
      );
    }
  };

  const ref = useRef<any>(null);

  const {isFixed, setWrapper} = useScrollFixElement({
    // disable:props.disableSystem
  });

  useEffect(()=>{
    if(ref && ref.current) {
      setWrapper(ref);
    }
  }, [ref]);

  return (<Tags
    isFixed={isFixed}
    ref={ref}
    tags={tagList}
    id={selectTagId}
    onUpdateTagId={setSelectTagId}
    clickTag={clickTag}
    disableSystem={props.disableSystem}
    showall={props.showall}
    showperson={props.showperson}
    showhot={props.showhot}
  />);
};

// 注意，因为forwardRef的存在，这个组件不能inject!!!!!
export default AllForTag;
